module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av241-b7865b68496b0e979f44293356ac7c66.jpg";